import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Profile } from '@/types/user'

interface AuthState {
  profile: Profile | null
  setProfile: (p: Profile | null) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      profile: null,
      setProfile: (p) => set({ profile: p }),
    }),
    { name: 'stryzh-auth' },
  ),
)
